export default "__VITE_ASSET__DhzvgroA__"